import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { FloatingButton } from "components/FloatingButton";
import { default as playIcon } from "images/icons/play-solid.svg";
import * as React from "react";
import { useEffect, useRef } from "react";
import { videoAnalyticsEvents } from "./videoHelpers";

const useStyles = makeStyles((theme) => ({
    floatingButton: {
        marginBottom: 0,
    },

    container: {
        position: "relative",
    },
    videoColumn: {
        height: "100%",
        background: "black",
        width: "50%",
        position: "fixed",
        overflow: "hidden",

        [theme.breakpoints.down("md")]: {
            height: "50vh",
            width: "100%",
            position: "relative",
        },
        [theme.breakpoints.down("sm")]: {
            height: "30vh",
            width: "100%",
            position: "relative",
        },
    },

    video: {
        height: "100%",
        width: "100vw",
        maxWidth: "100%",
        display: "block",
        margin: "0 auto",
        objectFit: "cover",
    },

    contentWrapper: {
        minHeight: "100vh",
        position: "relative",
        width: "50%",
        marginLeft: "50%",
        textAlign: "left",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: theme.spacing(8),
        paddingTop: theme.spacing(20),

        [theme.breakpoints.down("md")]: {
            minHeight: "unset",
            width: "100%",
            marginLeft: 0,
            position: "relative",
            padding: theme.spacing(4),
            paddingBottom: theme.spacing(15),
        },
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(3),
            paddingBottom: theme.spacing(15),
        },
    },

    overlay: {
        position: "absolute",
        bottom: 0,
        width: "100%",
        color: theme.palette.coral100,
    },
    overlayText: {
        display: "inline-block",
        paddingLeft: theme.spacing(3),
    },
    playIcon: {
        paddingLeft: theme.spacing(3),

        display: "inline-block",
    },
}));

export const LandingTwoColumnLayout = (props: {
    onNext?: () => void;
    // onRouteToCurrentStep?: () => void;
    step?: number;
    content: React.ReactNode;
    continueButtonText?: React.ReactNode;
    videoUrl: string;
    videoId: string;
    thumbnailUrl?: string;
    overlayText?: string;
    onVideoClick?: () => void;
    secondaryColumnFirst?: boolean;
    classes?: Partial<ReturnType<typeof useStyles>>;
    disableAnalytics?: boolean;
}) => {
    const classes = useStyles(props);

    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        const { current: videoElement } = videoRef;
        if (videoElement) {
            videoElement.setAttribute("muted", "");
        }
    }, []);

    const videoAnalytics = props.disableAnalytics ? {} : videoAnalyticsEvents(props.videoId);

    const renderPrimaryColumn = () => (
        <>
            <div className={classes.videoColumn} onClick={props.onVideoClick}>
                {props.overlayText && (
                    <div className={classes.overlay}>
                        <img src={playIcon} alt="" className={classes.playIcon} />
                        <Typography variant="body1" className={classes.overlayText}>
                            {props.overlayText}
                        </Typography>
                    </div>
                )}
                <video
                    loop
                    autoPlay
                    playsInline
                    muted
                    ref={videoRef}
                    className={classes.video}
                    key={props.videoUrl}
                    poster={props.thumbnailUrl}
                    {...videoAnalytics}
                >
                    <source src={props.videoUrl} type="video/mp4" />
                    Sorry, your browser doesn't support embedded videos.
                </video>

                {/* {props.step && (
                <div style={{ position: "absolute", top: 0, right: 0 }}>
                    <LandingFlowProgressIndicator
                        step={props.step}
                        onRouteToCurrentStep={
                            props.onRouteToCurrentStep
                        }
                    />
                </div>
            )} */}
            </div>
        </>
    );

    const renderSecondaryColumn = () => {
        return (
            <div className={classes.contentWrapper}>
                {props.content}

                {props.continueButtonText && (
                    <FloatingButton
                        variant="primary"
                        size="medium"
                        onClick={props.onNext}
                        className={classes.floatingButton}
                        data-testid="continueButton"
                    >
                        {props.continueButtonText}
                    </FloatingButton>
                )}
            </div>
        );
    };

    const renderColumns = () => {
        if (props.secondaryColumnFirst) {
            return (
                <>
                    {renderSecondaryColumn()}
                    {renderPrimaryColumn()}
                </>
            );
        } else {
            return (
                <>
                    {renderPrimaryColumn()}
                    {renderSecondaryColumn()}
                </>
            );
        }
    };

    return <div className={classes.container}>{renderColumns()}</div>;
};
